import CustomColumn from './CustomColumn';
export default CustomColumn;